const modelExtension = '.trb';

export function isTrbModelName(name: string): boolean {
  return name.endsWith(modelExtension);
}

export function getTrbModelName(id: string): string {
  return id + modelExtension;
}

export function getTrbModelId(trbModelName: string): string | null {
  if (!trbModelName.endsWith(modelExtension)) {
    return null;
  }

  // Remove only the last occurrence by slicing off the extension from the end
  return trbModelName.slice(0, -modelExtension.length);
}
